import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';

import Quill from 'quill';
import html2canvas from 'html2canvas';
import canvasToImage from 'canvas-to-image';

import styles from './Textfield.css';

import 'quill/dist/quill.core.css';
import 'quill/dist/quill.snow.css';
import 'quill/dist/quill.bubble.css';

import SvgIcon from '@material-ui/core/SvgIcon';
import { ReactComponent as ZoomOutIcon } from '@/icons/colorless/zoom_out.svg';
import { ReactComponent as ZoomInIcon } from '@/icons/colorless/zoom_in.svg';

// { setContentSize }
import actions from '@/action/content.js';


const Parchment = Quill.import('parchment');
const Block = Quill.import('blots/block');
const Inline = Quill.import('blots/inline');
const Embed = Quill.import('blots/embed');

// console.log('Parchment', Parchment);
// console.log('Block', Block);
// console.log('Inline', Inline);


// binary search largest without going over
let binarySearch = function (testFn, min, max) {
    // Iterate while start not meets end 
    let mid;
    let lastOk = min;

    while (max - min > 0.001){ 
        // Find the mid index 
        mid=(min + max)/2;
  
        // look in left or right half accordingly 
        if (testFn(mid)) {
            min = mid;
            lastOk = mid;
        } else {
            max = mid;
        } 
    }

    // while (mid <= max){ 
    //     // Find the mid index 
    //     mid += .05
  
    //     // look in left or right half accordingly 
    //     if (testFn(mid)) {
    //         lastOk = mid;
    //     } else {
    //         break;
    //     } 
    // }
    
    
    // testFn(lastOk);
    return lastOk;
}


   



const doCapture = true;

/** Textfield component description */
class Textfield extends Component {
    constructor(props) {
        super(props);

        this.domRef = React.createRef();
        this.autoSizeRef = React.createRef();
        this.toolbarRef = React.createRef();

        this.buildEditor = this.buildEditor.bind(this);
        this.onChange = this.onChange.bind(this);
        this.autoSize = this.autoSize.bind(this);
        this.resizeTextAndReportWillFit = this.resizeTextAndReportWillFit.bind(this);

        // window.setInterval(this.autoSize, 5000);
    }

    componentDidMount () {
        if (!this.basicEditor) {
            this.buildEditor();
        }
    }

    componentDidUpdate() {
        if( this.props.textReady ){
            this.editor.root.innerHTML = '';// TextItem.getText(this.props);
            this.editor.update();
        }



        const editorEl = this.domRef.current.firstChild;
        // console.log(editorEl.scrollWidth, editorEl.clientWidth, editorEl.scrollHeight, editorEl.clientHeight);

        // if (this.domRef.current
        //     && this.props.width == 'auto'
        // ) {
        // console.log('@@', editorEl.scrollWidth, editorEl.clientWidth, editorEl.scrollHeight, editorEl.clientHeight);

        if  ((this.domRef.current && this.props.width == 'auto')
            ||
            this.props.contentWidth < editorEl.scrollWidth 
            || this.props.contentHeight < editorEl.scrollHeight
        ) {
            // console.log('HERP!')
            //TODO: This is causing update loops :(
            // this.props.setContentSize(
            //     this.props.id,
            //     (editorEl.scrollWidth + 2), 
            //     (editorEl.scrollHeight + 2)
            // )
        }
        // } else {
        // }

        if (this.props.active) {
            this.editor.enable();
            const selection = this.editor.getSelection();
            // console.log('selection', selection);
            if (selection == null) {
                this.editor.setSelection(this.editor.getText().length-1)
            } else {
                this.editor.setSelection(selection.index, selection.length);
            }
        } else {
            if (this.editor.isEnabled() && doCapture) {

                // console.log(this.editor.getLines())

                // console.log('?!a', new Date().getMilliseconds());

                // html2canvas(this.domRef.current, {backgroundColor: null})
                // .then(
                //     canvas => {
                //         // console.log('?!b', canvasToImage)
                //         //canvasToImage(canvas, this.domRef.current.width, this.domRef.current.height);
                //         console.log('?!b', new Date().getMilliseconds());
                //     }
                // );
            }


            this.editor.disable();


        }




    }

    resizeTextAndReportWillFit = function (size) {
        // console.log('@', size);
        // size = 1;
        const containerEl = this.domRef.current;
        const editorEl = containerEl.firstChild;

        // console.log('##c1', editorEl.clientWidth, editorEl.scrollWidth);
        // console.log('##  ', editorEl.clientHeight, editorEl.scrollHeight);
        // console.log('##  ', editorEl.style.fontSize, editorEl.style.padding);

        editorEl.style.fontSize = size + "rem"; //(size * 16) + 'px'// 
        editorEl.style.padding = (size) + "rem";//(size * 2 * padding) + 'px'//


        // editorEl.style.display='none';
        // editorEl.offsetHeight; // no need to store this anywhere, the reference is enough
        // editorEl.style.display='';

        let willFit = editorEl.scrollWidth <= editorEl.clientWidth
        && editorEl.scrollHeight <= editorEl.clientHeight

        let cw1 = editorEl.clientWidth;
        let sw1 = editorEl.scrollWidth;
        let ch1 = editorEl.clientHeight;
        let sh1 = editorEl.scrollHeight;
        // editorEl.style.fontSize = (0.5*size) + "rem"; //(size * 16) + 'px'// 
        // editorEl.style.padding = (size) + "rem";//(size * 2 * padding) + 'px'//

        // let willFit2 = editorEl.scrollWidth <= editorEl.clientWidth
        // && editorEl.scrollHeight <= editorEl.clientHeight

        // let cw2 = editorEl.clientWidth;
        // let sw2 = editorEl.scrollWidth;


        /* 
        && editorEl.scrollWidth <= parseInt(window.getComputedStyle(editorEl.parentNode).width)
        && editorEl.scrollHeight <= parseInt(window.getComputedStyle(editorEl.parentNode).height)
        */

        // // let willFit = 
            // && editorEl.clientWidth <= this.props.contentWidth
            // && editorEl.clientHeight <= this.props.contentHeight;



        //  console.log ('##c0', containerEl.clientWidth, containerEl.clientHeight)
        //  console.log ('##c0', containerEl.scrollWidth, containerEl.scrollHeight)
        
        // console.log('##c', editorEl.clientWidth, editorEl.scrollWidth);
        // console.log('##c2', editorEl.clientHeight, editorEl.scrollHeight);
        // console.log('##  ', editorEl.style.fontSize, editorEl.style.padding);
        // console.log(willFit);

        editorEl.style.fontSize = 1 + "rem"; //(16) + 'px'// 
        editorEl.style.padding = 0;

        // console.log('* cn w', size, willFit, containerEl.scrollWidth, containerEl.clientWidth, this.props.contentWidth, bounds1.width)
        // console.log('* el w', size, willFit, editorEl.scrollWidth, editorEl.clientWidth, editorEl.scrollWidth <= editorEl.clientWidth);//, this.props.contentWidth, bounds1.width)
        // console.log('* el h', size, willFit, editorEl.scrollHeight, editorEl.clientHeight, editorEl.scrollHeight <= editorEl.clientHeight);//, this.props.contentHeight, bounds1.height)
        // console.log('resizeTextAndReportWillFit', size, willFit, 'scale', this.props.scale);
        // let n = parseInt(window.getComputedStyle(editorEl).width) + 2 * parseInt(window.getComputedStyle(editorEl).padding)

        if (editorEl.innerText == "oncexxxxxxx")
        {
            // if (! (cw1 == cw2 && sw1 == sw2)) {
                // console.log(size, cw1, cw2);
            // }
    
            // console.log('willfit?', 
            // size,
            // // 'contentW', 
            // //     this.props.contentWidth,
            // // 'clientW', 
            // editorEl.scrollWidth, 
            // editorEl.clientWidth, 
            // // window.getComputedStyle(containerEl).width, 
            // // window.getComputedStyle(editorEl).width, 
            // // n, 
            // willFit);

            window.thing = editorEl;
        }

        // if (willFit) {
        //     console.log(sw1, '<=', cw1, '&', sh1, '<=', ch1);
        // }


        return willFit;
    }

    autoSize (percentToFill) {
        // console.log('autosize!', this.props.id);
        const containerEl = this.domRef.current;
        if (!containerEl) {
            return;
        }
        const editorEl = containerEl.firstChild;

        let newScale;

        containerEl.style.padding = 0;
        // containerEl.style.fontSize = 1 + 'em';

        // console.log('##a', this.props.contentWidth, containerEl.style.width, containerEl.clientWidth, containerEl.scrollWidth, editorEl.style.width, editorEl.clientWidth, editorEl.scrollWidth);
        const oldTransform = containerEl.style.transform;
        const oldW = containerEl.style.width;
        const oldH = containerEl.style.height;

        containerEl.style.transform = ''; //`matrix(${this.props.z}, 0, 0, ${this.props.z}, ${this.props.tx}, ${this.props.ty})`;
        editorEl.style.fontSize =  1 + 'em'; // 16 + 'px'//(1)

        containerEl.style.width = (this.props.contentWidth * this.props.z) + 'px';
        containerEl.style.height = (this.props.contentHeight * this.props.z) + 'px';
        // containerEl.style.display = 'block';
        // editorEl.style.display = 'block';
        // editorEl.style.verticalAlign = 'middle';

        let computedSize = binarySearch(this.resizeTextAndReportWillFit, 0.1, 20);


        // const preciseFontSize = computedSize;  // Desired font size
        // const roundedSize = Math.ceil(preciseFontSize);
        // const s = preciseFontSize / roundedSize; // Remaining scale


        newScale = computedSize / this.props.z // this.scaleFoo;//Math.floor( * 10) / 10;
        // 1.52; // 0.827 * 

        // editorEl.removeChild(foo);

        // const preciseFontSize = newScale * this.props.scale;  // Desired font size
        // const roundedSize = Math.ceil(preciseFontSize);
        // const s = preciseFontSize / roundedSize; // Remaining scale

        // console.log('containerEl.style.fontSize', containerEl.style.fontSize, 'computedSize', computedSize, 'newScale', newScale, this.scaleFoo)


        //(16*computedSize) + 'px' // 
        containerEl.style.transform = oldTransform;
        containerEl.style.width = oldW;// (this.props.contentWidth * this.props.z / s),
        containerEl.style.height = oldH;// (this.props.contentHeight * this.props.z / s),
        // containerEl.style.display = '';
        // containerEl.style.gridTemplateColumns = '1fr';
        // editorEl.style.display = '';

        

        // console.log(oldW, 'x', oldH, ':', this.scaleFoo*parseInt(oldW), this.scaleFoo*parseInt(oldH) );

        // WHY DO WE HAVE TO HALF THIS???!
        containerEl.style.padding = 0.5 + 'em'; // padding + 'px';
        // console.log(this.props.content, roundedSize)
        // containerEl.style.fontSize = roundedSize + 'em';
        editorEl.style.fontSize = 1 + 'em'; //  16 + 'px'//
        // console.log('##c', containerEl.scrollWidth);

        // console.log('##b', this.props.contentWidth, containerEl.style.width, containerEl.clientWidth, containerEl.scrollWidth, editorEl.style.width)
        // console.log('##b1', editorEl.clientWidth, editorEl.scrollWidth);
        // console.log('##b2', editorEl.clientHeight, editorEl.scrollHeight);
        // console.log('newScale!', newScale, 'old', this.props.scale);
        this.props.setScale (this.props.id, percentToFill* newScale);
        // this.forceUpdate();
    }


    onChange (type, delta, source) {
        // console.log('DERP! onChange', type, delta);

        if (type=='text-change') {
            // window.setTimeout(this.autoSize, 10);
            if (this.props.autoSize){
                this.autoSize(this.props.autoSize);
            }
        }


        // editorEl.style.fontSize = "3rem";
        // // textfit(this.autoSizeRef.current);

        // console.log('post.onChange', editorEl.getBoundingClientRect(), editorEl.scrollWidth, editorEl.scrollHeight);
        return;
/*
        const bounds = this.editor.getBounds(0, this.editor.getText().length-1);
        // console.log('bounds', bounds);

        if (this.props.contentWidth < bounds.width + 32
            || 
            this.props.contentHeight < bounds.height + 26) {
                this.props.setContentSize(
                    this.props.id, 
                    Math.max(this.props.contentWidth, bounds.width + 32),
                    Math.max(this.props.contentHeight, bounds.height + 26)
                );
        }



        // console.log('%%', editorEl.scrollWidth, editorEl.clientWidth, editorEl.scrollHeight, editorEl.clientHeight);

        if  ((this.domRef.current && this.props.width == 'auto')
            ||
            this.props.contentWidth < editorEl.scrollWidth 
            || this.props.contentHeight < editorEl.scrollHeight
        ) {
            this.props.setContentSize(this.props.id,
                (editorEl.scrollWidth + 2), 
                (editorEl.scrollHeight + 2)
            )
        }
*/

        /* source === api | user */
        if(source === 'api'){
            return;
        }
        



        // this.html = this.editor.root.innerHTML;

        // if (this.onChangeTimeout) {
        //     clearTimeout(this.onChangeTimeout);
        //     this.onChangeTimeout = null;
        // }

        // this.onChangeTimeout = setTimeout(() => this.commitValue(), 300);
    }

    buildEditor() {
        if (!this.domRef.current || !this.toolbarRef.current) {
            return;
        }

        const options = {
            // debug: 'info',
            modules: {
                toolbar: {
                    container: this.toolbarRef.current,  // Selector for toolbar container
                    formats: 
                    ['align', 'background', 'header', 'font', 'size', 'align', 'bold', 'italic', 'underline',
                        'strike', 'script', 'list', 'bullet', 'indent', 'link', 'color', 'clean'],
                    // handlers: {
                    //   'bold': customBoldHandler
                    // }
                  },
                  clipboard: {
                    matchVisual: false
                  }
            },

            placeholder: '   ',
            readOnly: true,
            theme: 'snow'
          };
                        
          Quill.register(new Parchment.Attributor.Style('float', 'float', { 
            whitelist: ['left', 'right', 'center']
        }));


        Quill.register(
            new Parchment.Attributor.Style('width', 'width', { 
            })
        )
        Quill.register(
            new Parchment.Attributor.Style('height', 'height', { 
            })
        )

        //shape-outside
        Quill.register(
            new Parchment.Attributor.Style('shape-outside', 'shape-outside', { 
            })
        )

        //border-radius: 50%
        Quill.register(
            new Parchment.Attributor.Style('class', 'class'
            // , { 
            //     whitelist: ['diamond-left', 'diamond-right']
            // }
            )
        )


        Quill.register(
            new Parchment.Attributor.Style('display', 'display', { 
            })
        )
        Quill.register(
            new Parchment.Attributor.Style('padding-top', 'padding-top', { 
            })
        )

        class ShapeLeftBlot extends Block { 
            static create(value) {
                let node = super.create();
                // node.innerHTML = `<span contenteditable=false>&nbsp;</span>`;
                console.log('XXX1', node, arguments, node.outerHTML)
                return node;
            }
            static className = 'diamond-left';
            deleteAt() {
                return false
            }

            // static formats(x) {
            //     console.log('XXX?', x, arguments);
            //     return true;
            // }
        }

        ShapeLeftBlot.blotName = 'shapeL';
        ShapeLeftBlot.tagName = 'span';

        class ShapeRightBlot extends Block { 
            static create(value) {
                let node = super.create();
                // node.innerHTML = `<span contenteditable=false>&nbsp;</span>`;
                console.log('XXX2', node, arguments, node.outerHTML)
                return node;
            }
            static className = 'diamond-right';
            deleteAt() {
                return false
            }

            // static formats(x) {
            //     console.log('XXX?', x, arguments);
            //     return true;
            // }
        }

        ShapeRightBlot.blotName = 'shapeR';
        ShapeRightBlot.tagName = 'span';
        
        Quill.register(ShapeLeftBlot);
        Quill.register(ShapeRightBlot);

        // var Block = Parchment.query('block');
        // // Block.tagName = 'div';
        // class NewBlock extends Block {}; NewBlock.tagName = 'div';
        // Quill.register(NewBlock /* or NewBlock */);


        this.editor = new Quill(this.domRef.current, options);

        
        // this.editor.setText(this.props.content || '');
        this.editor.setContents([])
        // initialize the content to exactly what we have in our server (i.e. what we saved the last time as validated/sanitized by our server)
        this.editor.clipboard.dangerouslyPasteHTML(this.props.content || '');

        // console.log('content:', this.props.content);

        // this.editor.formatText(0, this.editor.getText().length-1, 'size', 'huge');

        this.editor.on('editor-change', this.onChange);
        if (this.props.autoSize) {
            this.autoSize(this.props.autoSize);
        }

        // this.editor.clipboard.dangerouslyPasteHTML(this.props.content || '');

        // this.basicEditor.addModule('toolbar', {
        //   container: this.domRef.current
        // });
    }

    scaleUp () {
        this.props.scaleUp(this.props.id);
    }
    scaleDown () {
        this.props.scaleDown(this.props.id);
    }

    shouldComponentUpdate(nextProps, nextState) {
    
        // console.log(nextProps, nextState);
        for (var i in nextProps) {
            if (i=='fg'
                || i=='bg') {
                continue;
            }
            if (this.props[i] !== nextProps[i]) {
                // console.log(i, this.props[i], nextProps[i]);
                return true;
            }
        }
        return false;
    }

    render() {

        //, this.props.contentWidth, this.props.contentHeight);
        // console.log (this.props.scale, this.props.contentWidth, 'x', this.props.contentHeight, (this.props.contentWidth / this.props.contentHeight));

        const preciseFontSize = this.props.z * this.props.scale;  // Desired font size
        const roundedSize = Math.ceil(preciseFontSize);
        const s = preciseFontSize / roundedSize; // Remaining scale

        this.scaleFoo = s;
        
        // console.log('tf render');//, this.props.id, this.props.scale, s);
        // console.log('precise', preciseFontSize);
        // console.log('rounded', roundedSize);
        // console.log('matrix scale', s);
        // textElement.style.fontSize = `${roundedSize}px`;
        // console.log(this.props.content, s, preciseFontSize, roundedSize, `${roundedSize}em`);

        const transform = `matrix(${s}, 0, 0, ${s}, ${this.props.tx}, ${this.props.ty})`;
        // const transformPos = `matrix(1, 0, 0, 1, ${this.props.tx}, ${this.props.ty})`;
        // const transformScale = `matrix(${this.props.z}, 0, 0, ${this.props.z}, 0, 0)`;

        // console.log(this.domRef.current ? this.domRef.current.clientWidth : 'auto');

        return <>


        <div
            ref={this.toolbarRef}
            style={{
                //display: this.props.hidden && !this.props.selected ? 'none' : 'initial',
                visibility: !this.props.active ? 'hidden' : 'visible',
                // transform: this.props.hidden? 'none' : transform,

                position: 'absolute',
                width: 'fit-content',
                minWidth: '437px',
                // left: 0,
                // top: 0,
                left: this.props.tx + 'px',
                top: (this.props.ty - 80) + 'px',
            }}
        >
            <span className="ql-formats">
            <select className="ql-font"></select>
            <select className="ql-size"></select>
            </span>
            <span className="ql-formats">
            <button className="ql-bold"></button>
            <button className="ql-italic"></button>
            <button className="ql-underline"></button>
            <button className="ql-strike"></button>
            </span>
            <span className="ql-formats">
                <select className="ql-color"></select>
                <select className="ql-background"></select>
            </span>

            <br />

            {/* <span className="ql-formats">
            <button className="ql-script" value="sub"></button>
            <button className="ql-script" value="super"></button>
            </span> */}
            <span className="ql-formats">
            <button className="ql-header" value="1"></button>
            <button className="ql-header" value="2"></button>
            <button className="ql-blockquote"></button>
            <button className="ql-code-block"></button>
            </span>
            <span className="ql-formats">
            <button className="ql-list" value="ordered"></button>
            <button className="ql-list" value="bullet"></button>
            {/* <button className="ql-indent" value="-1"></button>
            <button className="ql-indent" value="+1"></button> */}
            </span>
            <span className="ql-formats">
            {/* <button className="ql-direction" value="rtl"></button> */}
            <select className="ql-align"></select>
            </span>
            {/* <span className="ql-formats">
            <button className="ql-link"></button>
            <button className="ql-image"></button>
            <button className="ql-video"></button>
            <button className="ql-formula"></button>
            </span> */}
            {/* <span className="ql-formats">
            <button className="ql-clean"></button>
            </span> */}
            <span className="ql-formats">
                <span className="ql-scale">
                    <label>Scale All:</label>
                    <button 
                        className="ql-scale-down"
                        onClick={()=>{this.scaleDown()}}
                    >
                        <SvgIcon><ZoomOutIcon /></SvgIcon>
                    </button>
                    <button
                        className="ql-scale-up"
                        onClick={()=>{this.scaleUp()}}
                    >
                        <SvgIcon><ZoomInIcon /></SvgIcon>
                    </button>
                </span>
            </span>

        </div>

        <div
            key={"container-"+this.props.id}

            ref={this.autoSizeRef}

            style={{
                //display: this.props.hidden && !this.props.selected ? 'none' : 'initial',
                visibility: this.props.hidden && !this.props.selected ? 'hidden' : 'visible',
                // transform: this.props.hidden? 'none' : transform,

                position: 'absolute',

                left: this.props.tx + 'px',
                top:  this.props.ty + 'px',
                width: (this.domRef.current ? (this.props.width): 'auto'),
                height: (this.domRef.current ? (this.props.height): 'auto'),
                
                // overflow: 'visible',

                // background: 'red',

                pointerEvents: 'all'
            }}
        >
            { this.props.fg }

        </div>    
        
        <div
            ref={this.domRef}

            className={`Textfield ql-container ql-snow ${this.props.dragging ? 'grabbing' : ''} ${this.props.active ? 'active' : ''} ${this.props.selected ? 'selected' : ''}   ${this.props.verticalAlignTop ? 'verticalAlignTop' : ''}  draggable resizable`}

            id={this.props.id}

            style={{
                position: 'absolute',
                // width: (this.props.contentwidth) + 'px',
                // height: (this.props.contentheight) + 'px',
                // width: 'fit-content',
                // height: 'fit-content',
                // fontSize: (this.props.scale/2) + 'em',
                // padding: '0.5rem', // padding + 'px', //Math.floor(10 * this.props.scale) +
                background: 'rgba(254, 244, 156, 1)',
// 
                width: Math.ceil(this.props.contentWidth * this.props.z / s) + 'px',
                height: Math.ceil(this.props.contentHeight * this.props.z / s) + 'px',

                fontSize: `${roundedSize}em`,

                transform: transform,
                // translate3d: '( 0, 0, 1000)',
                transformOrigin: '0% 0%',
                // backfaceVisibility: 'hidden',
                // '-webkit-font-smoothing': 'antialiased'

            }}
        >     
        </div>

        { this.props.bg }
    
        

        </>;


    }
}

const mapStateToProps = (state, ownProps) => {
    const z = state.camera.zoom;
    const panX = state.camera.pan.x;
    const panY = state.camera.pan.y;
    const cam_width = state.camera.size.width;
    const cam_height = state.camera.size.height;

    // console.log('ownProps', ownProps.width, ownProps.height, ownProps.scale); 

    return Object.assign(
        {}, 
        // {
        //     background,
        //     fg_color
        // },
        {
            itemsSelected: state.content.selection.length,
            active: ownProps.active,
            selected: ownProps.selected,
            // x: parseInt((ownProps.x + state.camera.pan.x) * state.camera.zoom + state.camera.size.width/2),
            // y: parseInt((ownProps.y + state.camera.pan.y) * state.camera.zoom  + state.camera.size.height/2),
            z: z,
            autoSize: ownProps.autoSize,
            scale: ownProps.scale,
            verticalAlignTop: ownProps.verticalAlignTop,

            // width: parseInt((ownProps.width*z)  ),
            // height: parseInt((ownProps.height*z) ),

            width: ownProps.width * z  || 'auto',
            height: ownProps.height * z  || 'auto',

            contentWidth:  ownProps.width || 'auto',
            contentHeight: ownProps.height || 'auto',

            content: ownProps.content,

            tx: parseInt((ownProps.x + panX) * z + cam_width/2),
            ty: parseInt((ownProps.y + panY) * z + cam_height/2),

            cam_width, 
            cam_height, 
            panX, 
            panY,

            // zoom: state.camera.zoom,
        }
    );
}

Textfield.displayName = "TextfieldComponent";
const connectedComponent = connect(
    mapStateToProps,
    {
        ...actions
    }
)(Textfield);
connectedComponent.displayName = "Textfield";


Textfield.propTypes = {

};

export default connectedComponent;
export { Textfield as TextfieldComponent };